import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './edm-network/HeroSection';
import { IntroSection } from './edm-network/IntroSection';
import { CategoryCardsSection } from './edm-network/CategoryCardsSection';
export function EDMNetworkPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2164">
      <SeoBar data-id="element-2165" />
      <Header data-id="element-2166" />
      <main className="flex-grow" data-id="element-2167">
        <div className="w-full bg-gray-50 pb-20 min-h-screen" data-id="element-2168">
          <HeroSection data-id="element-2169" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2170">
            <IntroSection data-id="element-2171" />
            <CategoryCardsSection data-id="element-2172" />
          </div>
        </div>
      </main>
      <Footer data-id="element-2173" />
    </div>;
}